import React, { useEffect } from 'react';
import {
  Paper,
  Tabs,
  Tab,
  TextField,
  Box,
  List,
  ListItem,
  ListItemText
} from '@mui/material';

const StudentList = ({
  currentTab,
  handleTabChange,
  t,
  searchTerm,
  setSearchTerm,
  filteredStudents,
  selectedStudentId,
  handleStudentChange
}) => {
  const selectedIndex = filteredStudents.findIndex(
    (student) => student.id === selectedStudentId
  );
  // useEffect za presretanje strelica
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'ArrowUp' && selectedIndex > 0) {
        // Pomeri selekciju na prethodnog učenika
        handleStudentChange(filteredStudents[selectedIndex - 1].id);
      } else if (
        event.key === 'ArrowDown' &&
        selectedIndex < filteredStudents.length - 1
      ) {
        // Pomeri selekciju na sledećeg učenika
        if (filteredStudents[selectedIndex + 1]) {
          handleStudentChange(filteredStudents[selectedIndex + 1].id);
        }
      }
    };

    // Dodaj event listener za 'keydown'
    window.addEventListener('keydown', handleKeyDown);

    // Ukloni event listener kada komponenta bude unmount-ovana
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedIndex, filteredStudents, handleStudentChange]);

  return (
    <Paper
      elevation={4}
      style={{
        padding: '20px',
        borderRadius: '16px',
        backgroundColor: '#f7f9fc',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)'
        // height: '100%'
      }}
    >
      <Tabs
        value={currentTab}
        onChange={handleTabChange}
        style={{
          marginBottom: '20px',
          borderBottom: '1px solid #ddd'
        }}
      >
        <Tab
          label={t('review.tabs.unreviewed')}
          style={{
            color: currentTab === 0 ? '#fff' : '#1976D2',
            backgroundColor: currentTab === 0 ? '#1976D2' : '#fff',
            borderRadius: '8px 8px 0 0',
            fontWeight: 'bold',
            padding: '10px',
            marginRight: '5px'
          }}
        />
        <Tab
          label={t('review.tabs.reviewed')}
          style={{
            color: currentTab === 1 ? '#fff' : '#1976D2',
            backgroundColor: currentTab === 1 ? '#1976D2' : '#fff',
            borderRadius: '8px 8px 0 0',
            fontWeight: 'bold',
            padding: '10px'
          }}
        />
      </Tabs>

      <TextField
        fullWidth
        label={t('review.searchStudent')}
        variant="outlined"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: '20px' }}
      />
      <Box
        sx={{
          height: 'calc(100% - 60px)',
          maxHeight: '600px',
          overflowY: 'auto',
          borderRadius: '8px',
          padding: '5px',
          backgroundColor: '#ffffff'
        }}
      >
        <List height={window.innerHeight - 150} width="100%">
          {filteredStudents.map((student) => (
            <ListItem
              key={student.id}
              button
              onClick={() => handleStudentChange(student.id)}
              style={{
                backgroundColor:
                  student.id === selectedStudentId ? '#1976D2' : '#f0f0f0',
                color: student.id === selectedStudentId ? '#fff' : '#000',
                borderRadius: '8px',
                margin: '5px 0',
                transition: 'background-color 0.3s ease',
                boxShadow:
                  student.id === selectedStudentId
                    ? '0px 4px 8px rgba(0, 0, 0, 0.1)'
                    : 'none'
              }}
            >
              <ListItemText
                primary={student.name}
                style={{ paddingLeft: '10px' }}
              />
            </ListItem>
          ))}
        </List>
      </Box>
    </Paper>
  );
};

export default StudentList;
